module.exports = __webpack_public_path__ + "assets/img/IMG029.9cd84e73.png";